/**
 * AlertBar component transition options.
 * Treat this file as an enum.
 * @module alertBarTransitionOptions
 * @category AlertBar
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * The AuthBar should transition down
 * @type {string}
 */
export const DOWN = "DOWN";

/**
 * The AuthBar should transition up
 * @type {string}
 */
export const UP = "UP";
